
export class PurchasedProductEntityModel {
        constructor(product) {
                const toNum = (v, fallback = 0) => {
                        const n = Number(v);
                        return Number.isFinite(n) ? n : fallback;
                };
                const unitRef = product.unit;
                const unitId =
                        unitRef == null ? null : typeof unitRef === "object"
                                ? unitRef.id
                                : unitRef;
                const lineTotal = toNum(product.total, 0);
                const lineDisc = toNum(product.discountAmount, 0);

                this.product_id = toNum(product.product_id, 0);
                this.quantity = toNum(product.received, 0);
                this.damage = product.damage != null && product.damage !== ""
                        ? toNum(product.damage, 0)
                        : 0;
                this.batch_id = product.batch && product.batch.id ? toNum(product.batch.id, 0) : 0;
                this.amount = Number((lineTotal - lineDisc).toFixed(2));
                const parsedUnitId =
                        unitId != null && unitId !== ""
                                ? Number(unitId)
                                : null;
                this.unit_id =
                        parsedUnitId != null && Number.isFinite(parsedUnitId)
                                ? parsedUnitId
                                : null;
                const rawDp = product.discountPercentage;
                this.discount_percentage = Array.isArray(rawDp)
                        ? 0
                        : toNum(rawDp, 0);
                this.discount_quantity = toNum(product.discount, 0);
            }
}
